import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const Title = styled.h1<any>`
  color: ${props => props.theme.palette.primary.alphaDark};
  font: ${font('default', 'bold', '24px/28px')};
  text-transform: none;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  ${props => props.action && `
    cursor: pointer;
  `}

  span {
    text-transform: uppercase;
    margin-left: 10px;
  }

  svg {
    width: 10px;
    margin-right: 15px;
    fill: ${props => props.theme.palette.general.grey};
  }
`

export const Container = styled.div`
  padding: 30px !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > div {
    margin-right: 1%;
    box-sizing: border-box;
    ${bp('sm')`
      width: 100% !important;
      margin: 0 auto 30px;
    `}
  }

  .no-data {
    margin: 30px auto;
    display: block;
    text-align: center;
    font: ${font('default', 'bold', '20px/1')};
  }

  .community {
    &__residents {
      background: rgba(205, 204, 207, 0.2);
      border-radius: 5px;
      padding: 15px;
      width: 40%;

      h3 {
        color: ${props => props.theme.palette.primary.alphaDark};
        font: ${font('default', 'medium', '20px/1')};
        margin: 0 0 15px;
      }

      &--heading {
        display: flex;
        color: ${props => props.theme.palette.general.greyDark};
        text-transform: uppercase;
        font: ${font('default', 'normal', '12px/1.2')};

        > div {
          width: 33%;

          &:nth-child(2) {
            text-align: center;
          }

          &:nth-child(3) {
            text-align: right;
          }
        }
      }

      ul {
        padding: 0;
        list-style: none;
        height: 500px;
        overflow-y: scroll;

        li {
          display: flex;
          justify-content: space-between;
          padding: 15px 0;
          border-bottom: 1px solid ${props => props.theme.palette.general.greyDark};
          margin-right: 10px;

          span {
            color: ${props => props.theme.palette.primary.alphaDark};
            font: ${font('default', 'medium', '14px/1.2')};
          }

          .input-wrapper {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 12px;
            font-size: 22px;
            user-select: none;

            input {
              position: absolute;
              opacity: 0;
              height: 0;
              width: 0;

              &:checked ~ .checkmark {
                background-color: ${props => props.theme.palette.primary.alpha};

                &::after {
                  display: block;
                }
              }
            }

            .checkmark {
              position: absolute;
              top: 0;
              left: 0;
              height: 16px;
              width: 16px;
              background-color: ${props => props.theme.palette.general.greyLight};
              border-radius: 2px;
              border: 1px solid ${props => props.theme.palette.general.grey};

              &::after {
                content: "";
                position: absolute;
                display: none;
                left: 4px;
                top: 0;
                width: 5px;
                height: 9px;
                border: solid ${props => props.theme.palette.general.light};
                border-width: 0 3px 3px 0;
                transform: rotate(45deg);
              }
            }
          }
        }
      }
    }

    &__report {
      width: 55%;

      &--item {
        background: rgba(205, 204, 207, 0.2);
        border-radius: 5px;
        text-align: center;
        padding: 15px;

        &:not(:last-child) {
          margin-bottom: 16px;
        }

        h3 {
          margin: 0 0 20px;
          text-transform: uppercase;
          letter-spacing: 1px;
          font: ${font('default', 'bold', '16px/1')};
        }

        span {
          display: block;
          text-transform: uppercase;
          color: ${props => props.theme.palette.primary.alphaDark};
          font: ${font('default', 'bold', '18px/1.5')};
          margin-bottom: 20px;
          ${bp('sm')`
            font: ${font('default', 'bold', '16px/1.5')};
          `}
        }

        div {
          color: ${props => props.theme.palette.general.greyDark};
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
`
